/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  LatLonResponse,
  PlaceScoreResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LatLonResponseFromJSON,
    LatLonResponseToJSON,
    PlaceScoreResponseFromJSON,
    PlaceScoreResponseToJSON,
} from '../models/index';

export interface GetLambertCenterLatLonRequest {
    zone: string;
    x1: number;
    x2: number;
    y1: number;
    y2: number;
}

export interface GetPlaceScoreRequest {
    latitude: number;
    longitude: number;
    radius?: number;
}

/**
 * 
 */
export class ToolsApi extends runtime.BaseAPI {

    /**
     * Calculates the center of a bounding box defined by Lambert 93 coordinates (EPSG:2154) and returns the corresponding WGS84 (EPSG:4326) longitude and latitude.
     * Convert Lambert 93 Bounding Box Center to Lat/Lon
     */
    async getLambertCenterLatLonRaw(requestParameters: GetLambertCenterLatLonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LatLonResponse>> {
        if (requestParameters['zone'] == null) {
            throw new runtime.RequiredError(
                'zone',
                'Required parameter "zone" was null or undefined when calling getLambertCenterLatLon().'
            );
        }

        if (requestParameters['x1'] == null) {
            throw new runtime.RequiredError(
                'x1',
                'Required parameter "x1" was null or undefined when calling getLambertCenterLatLon().'
            );
        }

        if (requestParameters['x2'] == null) {
            throw new runtime.RequiredError(
                'x2',
                'Required parameter "x2" was null or undefined when calling getLambertCenterLatLon().'
            );
        }

        if (requestParameters['y1'] == null) {
            throw new runtime.RequiredError(
                'y1',
                'Required parameter "y1" was null or undefined when calling getLambertCenterLatLon().'
            );
        }

        if (requestParameters['y2'] == null) {
            throw new runtime.RequiredError(
                'y2',
                'Required parameter "y2" was null or undefined when calling getLambertCenterLatLon().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['zone'] != null) {
            queryParameters['zone'] = requestParameters['zone'];
        }

        if (requestParameters['x1'] != null) {
            queryParameters['x1'] = requestParameters['x1'];
        }

        if (requestParameters['x2'] != null) {
            queryParameters['x2'] = requestParameters['x2'];
        }

        if (requestParameters['y1'] != null) {
            queryParameters['y1'] = requestParameters['y1'];
        }

        if (requestParameters['y2'] != null) {
            queryParameters['y2'] = requestParameters['y2'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tools/lambert`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LatLonResponseFromJSON(jsonValue));
    }

    /**
     * Calculates the center of a bounding box defined by Lambert 93 coordinates (EPSG:2154) and returns the corresponding WGS84 (EPSG:4326) longitude and latitude.
     * Convert Lambert 93 Bounding Box Center to Lat/Lon
     */
    async getLambertCenterLatLon(requestParameters: GetLambertCenterLatLonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LatLonResponse> {
        const response = await this.getLambertCenterLatLonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates the number of predefined points of interest (Hospitals, Schools, Restaurants, etc.) within a given radius of a WGS84 coordinate. It returns the individual counts and a consolidated \"livability\" score based on the density of these amenities. 
     * Get counts and a score for nearby points of interest
     */
    async getPlaceScoreRaw(requestParameters: GetPlaceScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlaceScoreResponse>> {
        if (requestParameters['latitude'] == null) {
            throw new runtime.RequiredError(
                'latitude',
                'Required parameter "latitude" was null or undefined when calling getPlaceScore().'
            );
        }

        if (requestParameters['longitude'] == null) {
            throw new runtime.RequiredError(
                'longitude',
                'Required parameter "longitude" was null or undefined when calling getPlaceScore().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['latitude'] != null) {
            queryParameters['latitude'] = requestParameters['latitude'];
        }

        if (requestParameters['longitude'] != null) {
            queryParameters['longitude'] = requestParameters['longitude'];
        }

        if (requestParameters['radius'] != null) {
            queryParameters['radius'] = requestParameters['radius'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tools/place-score`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceScoreResponseFromJSON(jsonValue));
    }

    /**
     * Calculates the number of predefined points of interest (Hospitals, Schools, Restaurants, etc.) within a given radius of a WGS84 coordinate. It returns the individual counts and a consolidated \"livability\" score based on the density of these amenities. 
     * Get counts and a score for nearby points of interest
     */
    async getPlaceScore(requestParameters: GetPlaceScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlaceScoreResponse> {
        const response = await this.getPlaceScoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
